export enum ENVIRONMENT {
  BETA = 'beta',
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
  STAGING = 'staging',
  QA = 'qa',
  TEST = 'test',
}
